import hotToast from 'react-hot-toast';

import type { ToastHandlers } from './types';

export const toast: ToastHandlers = {
  error: hotToast.error,
  info: hotToast.error,
  success: hotToast.success,
};
